export const itemStyle = {
    minWidth: 180,
    width: '100%',
    height: '100%',
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
}

export const dropdownStyle = {
    ...itemStyle,
    background: 'unset',
    justifyContent: 'space-between',
    width: '100%',
    flexGrow: 1,
}

export const navLinkStyle = {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    padding: '8px 10px',
}
